<script lang="ts">
    import { getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import type { SkinState, State } from "../../types/state";
    let state: Writable<State> = getContext("playerState");
    let skinState: Writable<SkinState> = getContext("skinState");

    import Button from "./../shared/Button.svelte";

    $: currentTime = $state.isLive
        ? $skinState.liveTimeFormatter($state.adapter?.currentUTC)
        : $skinState.vodCurrentTimeFormatter($state.adapter?.currentTime);

    function goLive() {
        $state.adapter?.goToLive();
    }
</script>

<div class="scotparl-time">
    {#if $state.isLive}
        <div>
            <Button label="live" on:click={goLive}>LIVE</Button>
            &nbsp;<time datetime={currentTime}>{currentTime}</time>
        </div>
    {:else}
        <div>
            <time datetime={currentTime}>{currentTime}</time>
        </div>
    {/if}
</div>

<style lang="scss">
    .scotparl-time {
        user-select: none;
        height: 3em;
        padding: 0 0.5em;

        div {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
        }
    }
</style>
